var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17L9.23703 15.2527C7.8311 13.8592 7.12813 13.1625 7.01989 12.3133C6.99337 12.1053 6.99337 11.8947 7.01989 11.6867C7.12813 10.8375 7.8311 10.1408 9.23703 8.74731L11 7",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17L15.237 15.2527C13.8311 13.8592 13.1281 13.1625 13.0199 12.3133C12.9934 12.1053 12.9934 11.8947 13.0199 11.6867C13.1281 10.8375 13.8311 10.1408 15.237 8.74731L17 7",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeft2);
export default __webpack_public_path__ + "static/media/pagination-left-2.3ea2f5d375da9a854bca4f96473877ca.svg";
export { ForwardRef as ReactComponent };